export const DATE_FIELDS = ["dated", "used_from", "used_to"];

export const ORG_TYPES = ["ООО", "ИП", "Самозанятый"]
export const TAX_TYPES = ["ОСНО", "УСН", "АУСН", "ЕСХН", "Патент"]